import React, { useState, useMemo } from 'react';
import style from './AdminSidebar.module.css';
import { Button, Menu } from 'antd';
import {
  AppstoreOutlined,
  ContainerOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  SettingOutlined,
  FileAddOutlined,
  UnorderedListOutlined,
  HomeOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

// Використовуємо keys як частини URL після /admin/...
// Наприклад: /admin/posts, /admin/posts/new
const AdminSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Визначаємо активний пункт з шляху
  const selectedKey = useMemo(() => {
    const parts = pathname.split('/').filter(Boolean); // ['admin', 'posts', 'new']
    if (parts[0] !== 'admin') return 'dashboard';
    return parts[1]
      ? parts[2]
        ? `${parts[1]}:${parts[2]}`
        : parts[1]
      : 'dashboard';
  }, [pathname]);

  const items = [
    { key: 'dashboard', icon: <PieChartOutlined />, label: 'Dashboard' },

    {
      key: 'posts',
      label: 'Posts',
      icon: <ContainerOutlined />,
      children: [
        {
          key: 'posts:list',
          icon: <UnorderedListOutlined />,
          label: 'All posts',
        },
        { key: 'posts:new', icon: <FileAddOutlined />, label: 'Create post' },
      ],
    },

    {
      key: 'projects',
      label: 'Projects',
      icon: <AppstoreOutlined />,
      children: [
        {
          key: 'projects:list',
          icon: <UnorderedListOutlined />,
          label: 'All projects',
        },
        {
          key: 'projects:new',
          icon: <FileAddOutlined />,
          label: 'Create project',
        },
      ],
    },

    { key: 'settings', icon: <SettingOutlined />, label: 'Settings' },

    {
      type: 'group',
      label: 'Navigation',
      children: [
        { key: 'site', icon: <HomeOutlined />, label: 'Back to site' },
        { key: 'help', icon: <MailOutlined />, label: 'Support' },
      ],
    },
  ];

  const onClick = ({ key }) => {
    // Карта переходів
    const map = {
      dashboard: '/admin',
      'posts:list': '/admin/posts',
      'posts:new': '/admin/posts/new',
      'projects:list': '/admin/projects',
      'projects:new': '/admin/projects/new',

      settings: '/admin/settings',
      site: '/',
      help: '/admin/support',
      posts: '/admin/posts',
      projects: '/admin/projects',
    };
    const to = map[key] || '/admin';
    navigate(to);
  };

  return (
    <aside className={style.sidebar} style={{ width: collapsed ? 80 : 256 }}>
      <div className={style.toggle}>
        <Button type="primary" onClick={() => setCollapsed(v => !v)} block>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div>

      <Menu
        className={style.menu}
        mode="inline"
        theme="dark"
        inlineCollapsed={collapsed}
        selectedKeys={[selectedKey]}
        defaultOpenKeys={['posts', 'projects']}
        onClick={onClick}
        items={items}
      />
    </aside>
  );
};

export default AdminSidebar;
